import { render, staticRenderFns } from "./ModalScanBoxPEI.vue?vue&type=template&id=1e722cd0&"
import script from "./ModalScanBoxPEI.vue?vue&type=script&lang=js&"
export * from "./ModalScanBoxPEI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports